export enum Breakpoint {
  TABLET = 640,
  DESKTOP = 1024
}
